export default __webpack_public_path__ + "static/media/coche.1ac771c1.svg";